export default {
    name: "GoBack",
    title: "Go Previous Page",
    icon: "mdi-arrow-left-bold-circle-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
        };
    },
};